import { Spotlight, SpotlightTransition } from '@atlaskit/onboarding';
import { N0 } from '@atlaskit/theme/colors';
import { useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { useFeatureFlags } from '@atlassian/mpac-feature-flags';
import { useParams } from '@atlassian/mpac-ui';
import { DeviceUtils, DOMUtils, SessionStorageUtils } from '@atlassian/mpac-utils';
import React, { useState } from 'react';
import { dismissSpotlightTourButtonAnalyticsConfig } from '../../PartnerReports.events';
import { handleInvariant } from '../../PartnerReports.utils';
import useQueryParamsUpdate from '../../ReportsFilters/useQueryParamsUpdate';
import chartMoreFilterImg from './chartMoreFilter.png';

// eslint-disable-next-line max-lines-per-function
const SpotlightTour = () => {
  const {
    partnerId,
    reportName
  } = useParams();
  const [activeSpotlight, setActiveSpotlight] = useState(null);
  const fireAnalyticsEvent = useAnalyticsEvents();
  handleInvariant(SpotlightTour.name, partnerId, 'Partner id is required');
  handleInvariant(SpotlightTour.name, reportName, 'Report name is required');
  const {
    updateQueryParams
  } = useQueryParamsUpdate(partnerId, reportName);
  const isMobile = DeviceUtils.isMobile();
  const {
    partnersNavigationRefresh
  } = useFeatureFlags();
  const start = () => {
    document.body.scrollTop = document.body.scrollHeight * 0.05;
    setActiveSpotlight(0);
  };
  const next = () => setActiveSpotlight((activeSpotlight || 0) + 1);
  const end = () => {
    fireAnalyticsEvent(dismissSpotlightTourButtonAnalyticsConfig({
      partnerId,
      label: 'Dismiss',
      value: 'reportsNewExperienceDismissButton'
    }));
    DOMUtils.scrollToDocumentTop();
    setActiveSpotlight(null);
  };
  const expandTableTree = () => {
    var _DOMUtils$getElementB, _DOMUtils$getElementB2;
    //since we cant directly add custom props to Row, we are getting StyledRow by its id, then accessing Row using children
    (_DOMUtils$getElementB = DOMUtils.getElementBySelector('[id="table-item1"]')) === null || _DOMUtils$getElementB === void 0 ? void 0 : (_DOMUtils$getElementB2 = _DOMUtils$getElementB.children[0]) === null || _DOMUtils$getElementB2 === void 0 ? void 0 : _DOMUtils$getElementB2.click();
    next();
  };
  const goToTransactions = () => {
    updateQueryParams({
      selectedOptionValue: 'transactions',
      selectedOptionQueryParam: '',
      shouldAppendUrl: true
    });
    next();
  };
  const scrollToBottomAndNext = () => {
    document.body.scrollTop = document.body.scrollHeight;
    next();
  };
  if (activeSpotlight === null && SessionStorageUtils.getFromStorage('startSpotlightTour')) {
    start();
    SessionStorageUtils.deleteFromStorage('startSpotlightTour');
  }

  // eslint-disable-next-line max-lines-per-function
  const renderActiveSpotlight = () => {
    const totalSpotlights = isMobile || partnersNavigationRefresh ? 4 : 5;
    const activeSpotlightStepNumber = "".concat((activeSpotlight || 0) + 1, "/").concat(totalSpotlights);
    const spotlights = [/*#__PURE__*/React.createElement(Spotlight, {
      image: chartMoreFilterImg,
      actions: [{
        onClick: () => goToTransactions(),
        text: 'Next'
      }, {
        onClick: () => end(),
        text: 'Dismiss',
        appearance: 'subtle'
      }],
      target: "chartMoreFilter",
      key: "chartMoreFilter",
      targetRadius: 3,
      targetBgColor: N0,
      dialogPlacement: DeviceUtils.isMobile() ? 'bottom center' : 'bottom right',
      actionsBeforeElement: activeSpotlightStepNumber,
      dialogWidth: 300
    }, "You can now toggle chart patterns in reports. Your selection will be applicable to all reports except the Feedback report."), /*#__PURE__*/React.createElement(Spotlight, {
      actions: [{
        onClick: () => next(),
        text: 'Next'
      }, {
        onClick: () => end(),
        text: 'Dismiss',
        appearance: 'subtle'
      }],
      target: "filters",
      key: "filters",
      targetRadius: 3,
      targetBgColor: N0,
      actionsBeforeElement: activeSpotlightStepNumber
    }, "Improved visibility & quick access to application and hosting type filters in the Transactions, Licenses and Feedback Details reports, allowing you to swiftly refine your data."), /*#__PURE__*/React.createElement(Spotlight, {
      actions: [{
        onClick: expandTableTree,
        text: 'Next'
      }, {
        onClick: () => end(),
        text: 'Dismiss',
        appearance: 'subtle'
      }],
      target: "row-1",
      key: "row-1",
      targetRadius: 3,
      targetBgColor: N0,
      actionsBeforeElement: activeSpotlightStepNumber
    }, "Expand the row to access and compare additional information."), /*#__PURE__*/React.createElement(Spotlight, {
      actions: [{
        onClick: () => isMobile ? end() : scrollToBottomAndNext(),
        text: isMobile ? 'Done' : 'Next'
      }, {
        onClick: () => end(),
        text: 'Dismiss',
        appearance: 'subtle'
      }],
      target: "moreDetails",
      key: "moreDetails",
      targetRadius: 3,
      actionsBeforeElement: activeSpotlightStepNumber,
      targetBgColor: N0
    }, "Access all the relevant information about transactions/licenses in a new tab."), ...(!isMobile || !partnersNavigationRefresh ? [/*#__PURE__*/React.createElement(Spotlight, {
      actions: [{
        onClick: () => end(),
        text: 'Done'
      }, {
        onClick: () => end(),
        text: 'Dismiss',
        appearance: 'subtle'
      }],
      target: "feedback",
      key: "feedback",
      targetRadius: 3,
      targetBgColor: N0,
      actionsBeforeElement: activeSpotlightStepNumber
    }, "Facing a problem or uncovered a bug? Share your feedback and help us improve.")] : [])];
    if (activeSpotlight === null) {
      return null;
    }
    return spotlights[activeSpotlight];
  };
  return /*#__PURE__*/React.createElement(SpotlightTransition, null, renderActiveSpotlight());
};
export default SpotlightTour;